/* eslint-disable @typescript-eslint/no-explicit-any */
import apiService from './api'
import { sanitizeQueryParams } from '../utility/helpers/apiHelper'
import type { TableSortValue } from "@src/shared/constants/sort-order.constants";


interface GetProductsParams {
  page?: number
  pageSize?: number
  search?: string
  status?: string
  categoryId?: number | null
  subCategoryId?: number | null
  orderBy?: string
  orderDirection?: TableSortValue
  [key: string]: any
}

export class ProductService {
  async getProducts(query: GetProductsParams) {
    return apiService.get('/products', { params: sanitizeQueryParams(query) })
  }

  async getProduct(id: number) {
    return apiService.get(`/products/${id}`)
  }

  async updateProductStatus(
    id: number,
    data: { status: string; rejectionReason?: string }
  ) {
    return apiService.patch(`/products/${id}/status`, data)
  }

  async updateProductFeatured(id: number, data: { isFeatured: boolean }) {
    return apiService.patch(`/products/${id}/featured`, data)
  }

  async updateProductTags(id: number, data: { tags: string[] }) {
    return apiService.patch(`/products/${id}/tags`, data)
  }

  async updateProductCategory(
    id: number,
    data: { categoryId: number | null }
  ) {
    return apiService.patch(`/products/${id}/category`, data)
  }

  async updateProductSubCategories(
    id: number,
    data: { subCategoryIds: number[] }
  ) {
    return apiService.patch(`/products/${id}/subcategories`, data)
  }
}

export const productService = new ProductService()
